import crop_list from "./crop_list";

const plots = {
        // Titles
        title: String("Plots"),
        plotsTableTitle: String("Manage my plots"),
        
        // Table headers
        plotName: String("Plot name"),
        plotCropId: String("Crop type"),
        plotTerrainBelongs: String("Associated terrain"),
        plotActionHeader: String("Actions"),

        // Buttons
        plotNewPlotButton: String("Add new plot"),
        plotPlotActionModify: String("Modify"),

        deletePromptModalTitle: String("Delete plot"),
        deleteModalBody: String("You are about to delete a plot. Once deleted it's impossible to restore it. Are you sure you want to delete it?"),
        deleteModalAccept: String("Delete"),
        deleteModalRejec: String("Cancelar"),
};
plots.crop_list = crop_list;

export default plots;